import * as ACTIONS from '../actions/constants';

const initialState = {
  cardTemplates: [],
};

function removeEvent(events, payload) {
  let newEvents = events.filter(event => event.id !== payload.id);

  if (payload.extras) {
    newEvents = newEvents.filter(event => event.cardName !== payload.extras);
  }

  return newEvents;
}

function eventFeed(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.UPDATE_EVENTS:
      if (state.events === action.payload) return state;
      return { ...state, events: [...action.payload] };
    case ACTIONS.REMOVE_EVENT:
      return { ...state, events: removeEvent(state.events, action.payload) };
    case ACTIONS.UPDATE_CARD_TEMPLATES:
      return { ...state, cardTemplates: action.payload };
    case ACTIONS.USER_LOG_OUT:
      return initialState;
    default:
      return state;
  }
}

export default eventFeed;



// WEBPACK FOOTER //
// ./src/reducers/eventFeed.js